<template>
    <TitledCardBase :title="$t('component.footer.title')">
        <div class="mt-5 m-auto">
            <img class="w-24 rounded rounded-full" src="../../assets/portrait_placeholder.png">
        </div>
        <div class="mt-2 text-gray-600 m-auto mb-2">
            <PersonalContact></PersonalContact>
        </div>
    </TitledCardBase>
</template>

<script>
    import TitledCardBase from "@/components/shared/TitledCardBase";
    import PersonalContact from "@/components/PersonalContact";
    export default {
        name: "Footer",
        components: {PersonalContact, TitledCardBase}
    }
</script>

<style scoped>

</style>